import { Footer } from './footer';
import { Header } from './header';

/*
      +--------------------------------+  ^
      |         Fixed Header           |  |
      +--------------------------------+  |
      |                                |  |
      |                                |  |
      |                                |  |
      |         Growing main           |  | min-height: 100vh
      |                                |  |
      |                                |  |
      |                                |  |
      +--------------------------------+  |
      |                                |  |
      |         Fixed Footer           |  |
      |                                |  |
      +--------------------------------+  v
*/
export default function Layout({ children }) {
  return (
    <div className="d-flex flex-column min-vh-100">
      <Header />
      <main data-gi={`td-home`} className="flex-grow-1 flex-shrink-1">
        {children}
      </main>
      <Footer />
    </div>
  );
}
